let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7zDle")).then(() => parcelRequire('7RLK4'));